export default {
  name: 'RemainingCounter',
  props: [
    'attributeName',
    'attributeId',
    'initialText',
    'className',
    'rows',
    'minlength',
    'maxlength',
    'summarizedLength',
    'totalRequiredLength',
    'required',
    'hasError',
  ],
  data() {
    return {
      content: this.initialText || '',
      otherTextsLength: 0,
    }
  },
  created() {
    this.otherTextsLength = this.summarizedLength - this.content.length
  },
  methods: {
    isClearedInput() {
      return (
        this.content.length + this.otherTextsLength >= this.totalRequiredLength
      )
    },
    countRemaining() {
      return (
        this.totalRequiredLength - this.otherTextsLength - this.content.length
      )
    },
  },
}
